export default __webpack_public_path__ + "assets/img/download-android.fd62fc8242f0778ebd11d6dda5d85939.svg";